// @ts-nocheck

import config from '../../../config/app.config';
import { CommonActionTypes } from '../../../types/actions/common';
import basketUtils from '../../../utils/basket';
import createReducer from '../../../utils/createReducer';
import { basketStatuses, actionTypes } from '../constants';

const {
  basket: { defaultStake },
} = config;

export const immersiveInitialState = {
  item: {},
  status: basketStatuses.EMPTY,
  message: null,
  defaultStake,
  stake: defaultStake,
  selectedBetGroupId: null,
};

const clearBasketItem = (state) => {
  return {
    ...state,
    item: {},
    message: null,
    status: basketStatuses.EMPTY,
  };
};

const addItem = (state, action) => {
  const { payload } = action;
  const { oddId, betId, value, betTitle, outcomeLabel } = payload;
  return {
    ...state,
    item: {
      betTitle,
      outcomeLabel,
      value,
      oddId,
      betId,
    },
    status: basketStatuses.OK,
  };
};

const submit = (state) => {
  return {
    ...state,
    status: basketStatuses.PENDING,
    message: null,
  };
};

const acceptChange = (state) => {
  return {
    ...state,
    item: {
      ...state.item,
      valueHasChanged: false,
    },
    status: basketStatuses.OK,
    message: null,
  };
};

const setStake = (state, action) => {
  const { stake } = action.payload;
  if (stake !== state.stake && basketUtils.isValidStake(stake)) {
    return {
      ...state,
      stake,
    };
  }
  return state;
};

const onValidated = (state, action) => {
  const { payload } = action;
  const { message = null, optionals = null } = payload;
  if (optionals) {
    const { validatedValue } = optionals;
    if (validatedValue && validatedValue !== state.item.value) {
      return {
        ...state,
        item: {
          ...state.item,
          validatedValue,
        },
        status: basketStatuses.VALIDATED,
        message,
      };
    }
  }
  return {
    ...state,
    status: basketStatuses.VALIDATED,
    message,
  };
};

const onWaitingTraderValidation = (state, action) => {
  const { payload } = action;
  const { message, traderId } = payload;
  return {
    ...state,
    item: { ...state.item, traderId },
    status: basketStatuses.WAITING_TRADER_VALIDATION,
    message,
  };
};

const onTraderNotification = (state, action) => {
  const { payload } = action;
  const { traderId, message, isAccepted } = payload;
  const isBasketWaitingValidation = state.status === basketStatuses.WAITING_TRADER_VALIDATION;
  const isBasketItemMatchNotification = state.item.traderId && state.item.traderId === traderId;
  if (isBasketWaitingValidation && isBasketItemMatchNotification) {
    return {
      ...state,
      status: isAccepted ? basketStatuses.VALIDATED : basketStatuses.ERROR,
      message,
    };
  }
  return state;
};

const onError = (state, action) => {
  const { payload } = action;
  const { message = null, optionals = null } = payload;
  if (optionals) {
    const { newValue, newStake } = optionals;
    if (newValue && newValue !== state.item.value) {
      return {
        ...state,
        item: {
          ...state.item,
          value: newValue,
          valueHasChanged: true,
        },
        status: basketStatuses.ERROR,
        message,
      };
    } else if (newStake && newStake !== state.stake) {
      return {
        ...state,
        status: basketStatuses.ERROR,
        stake: newStake,
        message,
      };
    }
  }
  return {
    ...state,
    status: basketStatuses.ERROR,
    message,
  };
};

const setSelectedBetGroup = (state, action) => {
  const { payload } = action;
  const { betGroupId } = payload;
  return {
    ...state,
    selectedBetGroupId: betGroupId,
  };
};

const resetPanelContent = () => {
  return immersiveInitialState;
};

const setDefaultStake = (state, action) => {
  const { payload } = action;
  const { defaultStake } = payload;
  return {
    ...state,
    defaultStake,
  };
};

const receiveEntities = (state, action) => {
  const { odds } = action.payload;
  const { item, status } = state;
  const itemOddId = item.oddId || null;
  const itemValue = item.value || null;
  if (
    status !== basketStatuses.PENDING &&
    status !== basketStatuses.WAITING_TRADER_VALIDATION &&
    status !== basketStatuses.VALIDATED &&
    odds &&
    itemOddId &&
    odds[itemOddId] &&
    odds[itemOddId] > 1 &&
    odds[itemOddId] !== itemValue
  )
    return {
      ...state,
      item: {
        ...state.item,
        value: odds[itemOddId],
        valueHasChanged: true,
      },
    };
  return state;
};

export const reducer = createReducer(immersiveInitialState, {
  [actionTypes.CLEAR_BASKET_ITEM]: clearBasketItem,
  [actionTypes.ADD_ITEM]: addItem,
  [actionTypes.SUBMIT]: submit,
  [actionTypes.ACCEPT_CHANGE]: acceptChange,
  [actionTypes.ON_VALIDATED]: onValidated,
  [actionTypes.ON_WAITING_TRADER_VALIDATION]: onWaitingTraderValidation,
  [actionTypes.ON_TRADER_NOTIFICATION]: onTraderNotification,
  [actionTypes.ON_ERROR]: onError,
  [actionTypes.SET_SELECTED_BET_GROUP]: setSelectedBetGroup,
  [actionTypes.RESET_PANEL_CONTENT]: resetPanelContent,
  [actionTypes.SET_DEFAULT_STAKE]: setDefaultStake,
  [actionTypes.SET_STAKE]: setStake,
  [CommonActionTypes.RECEIVE_ENTITIES]: receiveEntities,
});

const actionTypesValues = Object.keys(actionTypes).map((key) => actionTypes[key]);

export default (state = immersiveInitialState, action) => {
  if (-1 !== actionTypesValues.indexOf(action.type) || action.type === CommonActionTypes.RECEIVE_ENTITIES) {
    return reducer(state, action);
  }
  return state;
};
